import { gql } from '@apollo/client';

export const LOCAL_FILTERS = gql`
  query localFilters {
    brandNames @client
    modelNames @client
    powerSupplies @client
    gearTypes @client
    tractionTypes @client
    vendorType @client
    vehicleTypes @client
    regions @client
    defaultRegions @client
    provinces @client
    isListingActive @client
    isPriceTiedToLoan @client
    isVehicleCoveredByWarranty @client
    isPictureAvailable @client
    isVATDeductible @client
    interiorColors @client
    coatingColors @client
    priceLabels @client
    vehicleRegistrationDateISO8601 @client
    engineDisplacementInCM3 @client
    powerInHP @client
    vehicleKM @client
    priceInEUR @client
    orderBy @client
    eurotaxCodes @client
    modelVersions @client
    modelYear @client
    vendorNames @client
    defaultVendorName @client
    vendorName @client
    comparison @client
    prediction @client
    websites @client
    code @client
    optionals @client
    country @client
  }
`;
